import React from 'react';
import {
    Cell,
    Grid,
    H2,
    Type,
    Box,
} from '@saladbob/sassafras'

import Game from './Game';
import GameRR from './GameRR';
import ByGame from './ByGame';

import style from './bracket.module.css';

import { Game as GameType, Team } from '../../types'

type Props = {
    games: GameType[],
    tbGames: GameType[],
    standings? : any[],
    teams: Team[],
};

const rows = 13;

const Bracket4: React.FC<Props> = ({ games, standings, teams }) => {
    return (
        <div style={{ height: '100%', width: '100%'}}>
            <Grid
                className={style.roundRobin}
                columns="minMax(max-content, 800px) minMax(max-content, 1fr)"
                gridGap="xl"
            >
                <div>
                    <H2 font="leader" className={style.bracketHeading} color="primary" ps="md" mb="lg">SATURDAY ROUND ROBIN</H2>
                    <Grid gridGap="md" mb="xxl" ps="md">
                        <GameRR game={games[0]} />
                        <GameRR game={games[1]} />
                        <GameRR game={games[2]} />
                        <GameRR game={games[3]} />
                        <GameRR game={games[4]} />
                        <GameRR game={games[5]} />
                    </Grid>
                </div>
                <div>
                    <Grid
                        className={style.standings}
                        columns="1fr min-content min-content"
                        rows="min-content"
                        maxWidth="600px"
                        ms="auto"
                    >
                        <Cell column="1 / 4">
                            <H2 font="leader" className={style.bracketHeading} color="primary">STANDINGS</H2>
                        </Cell>
                        <Box bdColor="black" bdWidth="0 2px 2px 0" padding={['sm', 0]}>
                            <Type font="p" weight="bold" color="primary" className={style.standingsFont}>
                                TEAM
                            </Type>
                        </Box>
                        <Box bdColor="black" bdWidth="0 2px 2px 0" padding="sm" minWidth="32px" justify="center">
                            <Type font="p" weight="bold" color="primary" className={style.standingsFont}>
                                W
                            </Type>
                        </Box>
                        <Box bdColor="black" bdWidth="0 2px 2px 0" padding="sm" minWidth="32px" justify="center" >
                            <Type font="p" weight="bold" color="primary" className={style.standingsFont}>
                                L
                            </Type>
                        </Box>
                        {standings && standings.map((team, i) => (
                            <React.Fragment key={team.id}>
                                <Box bdColor="black" bdWidth="0 2px 2px 0" padding={['sm', 'sm', 'sm', 0]}>
                                    <Type font="p" weight="bold" color="secondary" className={style.standingsFont}>
                                        {i + 1}.
                                        {' '}
                                    </Type>
                                    <Type font="p" weight="bold" className={style.standingsFont}>
                                        {team.name}
                                    </Type>
                                </Box>
                                <Box bdColor="black" bdWidth="0 2px 2px 0" padding="sm">
                                    <Type font="p" display="block" align="right" className={style.standingsFont}>
                                        {team.wins}
                                    </Type>
                                </Box>
                                <Box bdColor="black" bdWidth="0 2px 2px 0" padding="sm">
                                    <Type font="p" display="block" align="right" className={style.standingsFont}>
                                        {team.losses}
                                    </Type>
                                </Box>
                            </React.Fragment>
                        ))}
                        {!standings && teams.length > 0 && teams.map((team, i) => (
                            <React.Fragment key={team.id}>
                                <Box bdColor="black" bdWidth="0 2px 2px 0" padding={['sm', 'sm', 'sm', 0]}>
                                    <Type font="p" weight="bold" color="secondary" className={style.standingsFont}>
                                        {i + 1}.
                                        {' '}
                                    </Type>
                                    <Type font="p" weight="bold" className={style.standingsFont}>
                                        {team.name}
                                    </Type>
                                </Box>
                                <Box bdColor="black" bdWidth="0 2px 2px 0" padding="xs">
                                </Box>
                                <Box bdColor="black" bdWidth="0 2px 2px 0" padding="xs">
                                </Box>
                            </React.Fragment>
                        ))}
                    </Grid>
                </div>
            </Grid>
            <H2 font="leader" className={style.bracketHeading} color="primary" ps="md" mb="xl">SUNDAY PLAYOFFS</H2>
            <Grid columns="repeat(5, max-content)">
                {/* Round 1 */}
                <Grid rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '1 / 3' }}>
                        <Game game={games[6]} />
                    </Cell>
                    <Cell style={{ gridRow: '5 / 7' }}>
                        <Game game={games[7]} />
                    </Cell>

                    {/* Losers */}

                    <Cell style={{ gridRow: '9 / 9' }} ps="md">
                        <H2 font="leader" color="primary" className={style.bracketHeading}>LOSERS BRACKET</H2>
                    </Cell>

                    <Cell style={{ gridRow: '11 / 13' }}>
                        <Game game={games[8]} trophy="toilet" trophyColor="black" />
                    </Cell>
                </Grid>
                {/* Round 2 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '2 / 6' }}>
                        <Game game={games[9]}   />
                    </Cell>

                    {/* Losers */}
                    
                    <Cell style={{ gridRow: '12 / 15' }}>
                        <Game game={games[10]} bottomLabel
                            trophy={'trophy'}
                            trophyColor={['#A05822', 'white']}
                        />
                    </Cell>
                </Grid>

                {/* Round 3 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '4 / 13' }}>
                        <Game game={games[11]} />
                    </Cell>
                </Grid>
                {/* Round 4 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`} className={`${style.championship} ${style.printOnly}`}>
                    <Cell style={{ gridRow: '9 / 11' }} width="100px">
                        <ByGame trophy loserTrophy />
                    </Cell>

                    <Cell style={{ gridRow: '11 / 13' }}>
                        <Game game={games[12]} />
                    </Cell>
                </Grid>
                {games[11].winner && games[11].team2.id === games[11].winner.id && (
                    <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`} className={`${style.championship} ${style.screenOnly}`}>
                        <Cell style={{ gridRow: '6 / 11' }} width="260px">
                            <Game game={games[12]} />
                        </Cell>
                    </Grid>
                )}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`} className={`${style.championship} ${style.screenOnly}`}>
                    <Cell style={{ gridRow: '9 / 11' }} width="100px">
                        <ByGame trophy loserTrophy />
                    </Cell>
                </Grid>
            </Grid>
        </div>
    );
}

export default Bracket4;
